import { render, staticRenderFns } from "./RadiationView.vue?vue&type=template&id=a537fe74&"
import script from "./RadiationView.vue?vue&type=script&lang=js&"
export * from "./RadiationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports